
































































































import Vue from 'vue';
import Siema from 'siema';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import * as Util from '@/util.ts';

export default Vue.extend({
  props: {
    isForLocationHoursModal: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      siema: {},
      id: Util.generateId(),
    };
  },
  computed: {
    showTakeoutOption(): boolean {
      return (this.$store.state.appMode !== Enums.eAppModes.takeout && this.$store.state.canOrderTakeoutForNowOrLater);
    },
    showDeliveryOption(): boolean {
      return (this.$store.state.appMode !== Enums.eAppModes.delivery && this.$store.state.canOrderDeliveryForNowOrLater);
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    takeoutAvailable(): boolean {
      return this.$store.state.takeoutAvailable;
    },
    deliveryAvailable(): boolean {
      return this.$store.state.deliveryAvailable;
    },
    tablesideAvailable(): boolean {
      return this.$store.state.tablesideAvailable && !this.$store.state.isEmbedded;
    },
    canGoToLocationSelection(): boolean {
      return this.$store.state.locationsToPickFrom?.length && this.$store.state.permalinkId;
    },
  },
  methods: {
    goToCodeEntry() {
      Util.rootComponent.showCodeEntryPageFunc();
    },
    switchToTakeout() {
      Util.switchToTakeout();
    },
    switchToDelivery() {
      Util.switchToDelivery();
    },
    onViewOnlySelected() {
      Util.switchToViewOnly();
    },
    goToLocationSelection() {
      Util.routerPush({ path: Constants.allRoutes.locationSelection });
    },
  },
});
